module.exports = __webpack_public_path__ + "static/img/20.3fd6fe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/20.png
// module id = zgUz
// module chunks = 1